import { useEffect, useState, useRef, useCallback } from "react";
import { WidgetConfigProvider, RemoteWidget } from "@tiktokshop/widget-kit-react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { getShops } from "actions/shopActions";
import { getWidgetToken } from "actions/websiteActions";
import Loading from "components/Loading";
import SelectBox from "components/elements/selectBox";

const ProductOptimize = ({ getShops, shop, getWidgetToken }) => {
    const [widgetName, setWidgetName] = useState("");
    const [selectedShop, setSelectedShop] = useState(""); // mặc định rỗng
    const [configData, setConfigData] = useState(null);
    const [tokenData, setTokenData] = useState(null);
    const refreshTimer = useRef(null);
    const isFetchingRef = useRef(false); // ✅ ngăn spam call
    const { t } = useTranslation();

    const { list, isLoading } = shop;

    useEffect(() => {
        getShops({ page: 1, sizeperpage: 9999 });
    }, [getShops]);

    const fetchToken = useCallback(async () => {
        if (!selectedShop) return;
        if (isFetchingRef.current) return; // đang fetch thì bỏ qua
        isFetchingRef.current = true;

        try {
            setConfigData(null)
            setTokenData(null)
            setWidgetName("@tiktokshop-widget/product:optimizer")
            const res = await getWidgetToken(selectedShop);
            const data = res?.data;

            if (data?.widget_token?.token) {
                const { shopId, key, region, widget_token } = data;

                setConfigData({
                    shopId,
                    oecRegion: region,
                    appKey: key,
                    isvInfo: { name: "OPEN_PLATFORM" },
                });

                setTokenData(widget_token);

                // setup refresh trước khi hết hạn 1 phút
                if (refreshTimer.current) clearTimeout(refreshTimer.current);
                const now = Math.floor(Date.now() / 1000);
                const ttl = widget_token.expire_at - now;
                if (ttl > 60) {
                    refreshTimer.current = setTimeout(fetchToken, (ttl - 60) * 1000);
                }
            } else {
                setConfigData(null)
                setTokenData(null)
                setWidgetName("")
            }
        } catch (err) {
            console.error("Fetch widget token failed:", err);
        } finally {
            isFetchingRef.current = false;
        }
    }, [selectedShop, getWidgetToken]);

    // reset token mỗi khi đổi shop
    useEffect(() => {
        if (!selectedShop) return;

        setConfigData(null);
        setTokenData(null);
        fetchToken();

        return () => {
            if (refreshTimer.current) clearTimeout(refreshTimer.current);
        };
    }, [fetchToken, selectedShop]);

    // Hàm SDK gọi → luôn trả token cache
    const getToken = async () => {
        if (!tokenData) return {};
        return tokenData; // { token, expire_at }
    };

    return (
        <div className="mb-5 mb-xl-10">
            <Loading isLoading={isLoading} />

            {/* SelectBox luôn hiển thị */}
            <div className="row col-md-3">
                <label>Select Shop Optimize:</label>
                <SelectBox
                    options={list?.filter((s) => s.member_note !== "The seller is inactive.")?.map((v) => ({
                        label: `${v?.name} - ${v?.note} - ${v.code}`,
                        value: v?._id?.toString(),
                    }))}
                    name="selectedShop"
                    value={selectedShop || ""}
                    onChange={(data) => {
                        setSelectedShop(data.value || "");
                    }}
                    placeholder={t("Select shop")}
                />
            </div>

            {/* Render widget khi có token & config */}
            {configData && tokenData ? (
                <WidgetConfigProvider
                    key={`${selectedShop}-${widgetName}`} // ✅ ép remount khi đổi shop
                    config={configData}
                    getToken={getToken}
                    remotes={[
                        // { name: "@tiktokshop-widget/merchant:OverviewWidget" },
                        // { name: "@tiktokshop-widget/merchant:InspirationWidget" },
                        // { name: "@tiktokshop-widget/merchant:MakeContentWidget" },
                        // { name: "@tiktokshop-widget/reverse:ManageReturns" },
                        // { name: "@tiktokshop-widget/logistics:warehouse" },
                        // { name: "@tiktokshop-widget/logistics:shippingTemplate" },
                        { name: "@tiktokshop-widget/product:optimizer" },
                    ]}
                    preloadWidgetNames={[
                        // "@tiktokshop-widget/merchant:OverviewWidget",
                        // "@tiktokshop-widget/merchant:InspirationWidget",
                        // "@tiktokshop-widget/merchant:MakeContentWidget",
                        // "@tiktokshop-widget/reverse:ManageReturns",
                        // "@tiktokshop-widget/logistics:warehouse",
                        // "@tiktokshop-widget/logistics:shippingTemplate",
                        "@tiktokshop-widget/product:optimizer",
                    ]}
                >
                    <RemoteWidget
                        key={`${selectedShop}-${widgetName}`} // ép remount khi đổi shop
                        name={widgetName}
                        // name="@tiktokshop-widget/product:optimizer"
                        className="containerClass"
                        options={{}}
                    />
                </WidgetConfigProvider>
            ) : (
                selectedShop && (
                    <div className="d-flex justify-content-center align-items-center">
                        Loading widget...
                    </div>
                )
            )}
        </div>
    );
};

const mapStateToProps = ({ shop }) => ({ shop });
const mapDispatchToProps = { getShops, getWidgetToken };

export default connect(mapStateToProps, mapDispatchToProps)(ProductOptimize);
